// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
import React from "react";
import { render } from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import createStore from "./redux/store";
import initialState from "./redux/store/initialState";
import { createBrowserHistory } from "history";
import { configureFakeBackend } from "./Pages/Login/_helpers";
import { Router } from "react-router-dom";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

//import './Pages/FacilityManager/View/__test__/viewFm.test';

const nonce = document
  .querySelector('meta[property="csp-nonce"]')
  ?.getAttribute("content");

export const createEmotionCache = (nonce) =>
  createCache({
    key: "mui",
    nonce,
  });

const emotionCache = createEmotionCache(nonce);

const history = createBrowserHistory();
const store = createStore(history, initialState);
configureFakeBackend();

render(
  <CacheProvider value={emotionCache}>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </CacheProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
